export class ArticleMetaModel {
  articleListApi: string = "";
  articleInfoByNoApi: string = "";
  articleByIdApi: string = "";
  updateNotesApi: string = "";
  updateHoldReleaseApi: string = "";
  updateArticleApi: string = "";
  articleTypeApi: string = "";
  specialissuetitleApi: string = "";
  articleSubjectApi: string = "";
  uploadFirstReleaseApi: string = "";
  statusListApi: string = "";
  journalListApi: string = "";
  LanguageCountryListApi: string = "";
  egApprove: string = "";
  eptApprove: string = "";
  downloadFpApi: string = "";
  downloadWfApi: string = "";
  uploadCorrectionApi: string = "";
  oneMoreReviewApi: string = "";
  approveApi: string = "";
  allocationApi: string = "";
  transactionApi: string = "";
  relatedArticleApi: string = "";
  GetJournalList: string = "";
  VolumeIssueListAPI: string = "";

  FieldConfigList: string = "";
  ClientApiCall: string = "";
  ClientApiCallAF: string = "";

  CorrectionTypeList: string = "";
  UpdateReopenArticle: string = "";

}
